/** @format */

import {Box, styled, TextField, Typography} from '@mui/material';

export const Container = styled(Box)(({theme}) => ({
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  marginTop: theme.spacing(4),
}));

export const DescriptionWrapper = styled(Box)(({theme}) => ({
  marginBottom: theme.spacing(4),
}));

export const Description = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
}));

export const FieldLabelWrapper = styled(Box)(({theme}) => ({
  marginBottom: theme.spacing(2),
}));

export const FieldLabel = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.surface.onSurface,
  fontSize: '18px',
  lineHeight: '22px',
}));

export const FieldWrapper = styled(Box)(({theme}) => ({
  marginBottom: theme.spacing(4),
}));

export const StyledTextField = styled(TextField)(({theme}) => ({
  display: 'flex',
  width: '350px',
  marginTop: theme.spacing(2),
}));

